import { ImageData, Size, Point, Triangle, Color, CanvasData } from "../types";

export const addImage = (
    context: CanvasRenderingContext2D,
    image: HTMLImageElement,
    size: Size
) => {
    context.canvas.width = size.width;
    context.canvas.height = size.height;
    context.drawImage(image, 0, 0, size.width, size.height);
};

export const getResizedSize = (size: Size) => {
    const desiredWidth = 600;
    const desiredHeight = 400;
    const ratioWidth = desiredWidth / size.width;
    const ratioHeight = desiredHeight / size.height;
    const ratio = Math.min(ratioWidth, ratioHeight);
    return {
        width: Math.round(size.width * ratio),
        height: Math.round(size.height * ratio),
    };
};

export const getImageData = (canvasData: CanvasData) => {
    if (canvasData.context) {
        return canvasData.context.getImageData(
            0,
            0,
            canvasData.size.width,
            canvasData.size.height
        ).data as unknown as ImageData;
    } else {
        return [];
    }
};

export const getInitialPoints = (size: Size) => {
    const points: Point[] = [];
    const initialPoints = 9;
    let x = 0;
    let y = 0;
    for (let i = 0; i < initialPoints; i++) {
        const px = (x * size.width) / 2;
        const py = (y * size.height) / 2;
        const point: Point = {
            x: px,
            y: py,
        };
        points.push(point);
        x++;
        if (x === 3) {
            x = 0;
            y++;
        }
    }
    return points;
};

export const getInitialTriangles = function (points: Point[]) {
    const intialTriangles = 8;
    const triangles: Triangle[] = [];
    for (let i = 0; i < intialTriangles; i++) {
        const row = Math.floor(i / 4);
        const col = Math.floor((i % 4) / 2);
        const a = row * 3 + col + 1;
        const b = a + 2;
        const c = i % 2 === 0 ? a + 3 : a - 1;
        const color = [0, 0, 0] as Color;
        const triangle: Triangle = {
            A: points[a],
            B: points[b],
            C: points[c],
            color,
            deviation: 0,
            pixels: [],
            active: true,
            fresh: true,
        };
        triangles.push(triangle);
    }
    return triangles;
};

export const drawTriangles = (
    canvasData: CanvasData,
    triangles: Triangle[],
    color: Color | null = null
) => {
    const size = 1;
    if (canvasData.context) {
        for (const triangle of triangles) {
            const c = color ? color : triangle.color;
            canvasData.context.fillStyle = "rgba(" + c + ", 1)";
            canvasData.context.beginPath();
            canvasData.context.moveTo(size * triangle.A.x, size * triangle.A.y);
            canvasData.context.lineTo(size * triangle.B.x, size * triangle.B.y);
            canvasData.context.lineTo(size * triangle.C.x, size * triangle.C.y);
            canvasData.context.closePath();
            canvasData.context.fill();
        }
    }
};

export const clearCanvas = (canvasData: CanvasData) => {
    if (canvasData.context) {
        canvasData.context.fillStyle = "rgb(255,255,255)";
        canvasData.context.fillRect(
            0,
            0,
            canvasData.size.width,
            canvasData.size.height
        );
    }
};
